module.exports = __webpack_public_path__ + "media/images/img_mentor03-f6818b05f39061de554fd5444d4c3d7e.jpg";